import React, { useState } from 'react'

const SESSIONS_PREVIEW_COUNT = 5

const UpcomingEventCard = ({ event, sessions, onSelectSession }) => {
    const [expanded, setExpanded] = useState(false)
    const hasMore = sessions.length > SESSIONS_PREVIEW_COUNT
    const visibleSessions = expanded ? sessions : sessions.slice(0, SESSIONS_PREVIEW_COUNT)

    return (
        <div className='fobk-surface-card upcoming-event-card'>
            <div className='upcoming-event-card__header'>
                <h3 className='upcoming-event-card__name'>{event.name}</h3>
                {event.difficulty && <span className='data-pill'>{event.difficulty}</span>}
            </div>
            {event.description && (
                <p style={{ fontSize: '0.875rem', color: 'var(--fobk-ink-muted)', margin: '0 0 0.85rem', lineHeight: 1.55 }}>
                    {event.description.length > 120 ? event.description.slice(0, 120) + '…' : event.description}
                </p>
            )}
            <ul className={`upcoming-event-card__sessions${expanded ? ' upcoming-event-card__sessions--expanded' : ''}`}>
                {visibleSessions.map(session => (
                    <li key={session._id} className='upcoming-event-card__session'>
                        <div>
                            <span className='upcoming-session-date'>
                                {new Date(session.date).toLocaleDateString('en-MY', { weekday: 'short', day: 'numeric', month: 'short' })}
                            </span>
                            <span className='upcoming-session-time'>{session.starttime} – {session.endtime}</span>
                        </div>
                        <div className='upcoming-session-right'>
                            <span className='upcoming-session-spots'>
                                {Math.max(0, event.capacity - (session.registrations || 0))} spots left
                            </span>
                            <button
                                type='button'
                                className='session-register-btn'
                                onClick={() => onSelectSession(event, session)}
                            >
                                Register →
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
            {hasMore && (
                <button
                    type='button'
                    className='upcoming-sessions-toggle'
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? 'Show less' : `View more (${sessions.length - SESSIONS_PREVIEW_COUNT})`}
                </button>
            )}
        </div>
    )
}

const UpcomingEventsGrid = ({ upcomingEventSessions, onSelectSession }) => {
    if (!upcomingEventSessions || upcomingEventSessions.length === 0) return null

    return (
        <div className='upcoming-events-grid'>
            {upcomingEventSessions.map(({ event, sessions }) => (
                <UpcomingEventCard key={event._id} event={event} sessions={sessions} onSelectSession={onSelectSession} />
            ))}
        </div>
    )
}

export default UpcomingEventsGrid
